// extracted by mini-css-extract-plugin
export var quillEditor = "_mf-1";
export var variable = "_mf-0";